<ng-container *transloco="let t">
  <div class="space-y-5">
    <div class="flex justify-end items-center">
      <div class="flex">
        <button
          nz-button
          nzType="primary"
          (click)="onClickAdd('new', '', '')"
          class="flex items-center justify-center gap-2">
          <lucide-icon name="plus" class="icon-size"></lucide-icon>
          {{ t('settings.preferences.categories.addCategory') }}
        </button>
      </div>
    </div>
    <nz-table
      #basicTable
      [nzData]="allCategories"
      [nzShowSizeChanger]="pageSize.length > 5"
      [nzPageSizeOptions]="pageSize.pageSizeOptions"
      [nzBordered]="true"
      [nzFrontPagination]="false"
      [nzTotal]="pageSize.length"
      [nzPageSize]="pageSize.pageSize"
      [nzPageIndex]="pageSize.pageIndex"
      (nzQueryParams)="onTableParamsChange($event)"
      [nzScroll]="{ x: '900px' }">
      <thead>
        <tr>
          <th [nzSortFn]="sortColumn.compareName" nzWidth="100px">{{ t('settings.preferences.categories.table.name') }}</th>
          <th [nzSortFn]="sortColumn.compareDate" nzWidth="100px">
            {{ t('settings.preferences.categories.table.createdDate') }}
          </th>
          <th nzWidth="100px">
            {{ t('settings.preferences.categories.table.action') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td class="capitalize">{{ data.name }}</td>
          <td>{{ data.createdAt | date }}</td>
          <td
            class="flex flex-row gap-3">
            <button
              nz-button
              nzType="default"
              nzSize="small"
              (click)="onClickEdit('edit', data._id, data.name)"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="pencil" class="icon-size"></lucide-icon>
              {{ t('settings.preferences.categories.edit') }}
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
